import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, provide } from 'intact-vue';
import template from './index.vdt';
import { toggleArray } from '../utils';
export * from './item';
import { useConfigContext } from '../config';
var typeDefs = {
  value: Array,
  accordion: Boolean,
  arrow: String,
  noBorder: Boolean
};
export var COLLAPSE = 'Collapse';
var defaults = function defaults() {
  return {
    arrow: 'right'
  };
};
export var Collapse = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Collapse, _Component);
  function Collapse() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Collapse.prototype;
  _proto.init = function init() {
    provide(COLLAPSE, this);
  };
  _proto.changeValue = function changeValue(v) {
    var _this$get = this.get(),
      value = _this$get.value,
      accordion = _this$get.accordion;
    var _value = accordion ? this.isActive(v) ? [] : [v] : toggleArray(value, v);
    this.set('value', _value);
  };
  _proto.isActive = function isActive(v) {
    var _this$get2 = this.get(),
      value = _this$get2.value;
    if (!Array.isArray(value)) return false;
    return !!~value.indexOf(v);
  };
  return Collapse;
}(Component);
Collapse.template = template;
Collapse.typeDefs = typeDefs;
Collapse.defaults = defaults;